function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7FFFF",
  d: "M12.254 28.004h140v53.2h-140z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#184169",
  d: "M163.358 145.604l.636 3.696a11.2 11.2 0 0 1-11.044 13.104H11.55A11.203 11.203 0 0 1 .513 149.3l.635-3.696h162.21zM141.054.004c6.185 0 11.2 5.014 11.2 11.2v16.8h-140v-16.8c0-6.186 5.014-11.2 11.2-11.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DEF0F0",
  d: "M152.254 81.204h-140l-11.106 64.4h162.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9FA7A7",
  d: "M85.054 89.604v5.997a11.202 11.202 0 0 1 8.4 10.803h-5.6a5.6 5.6 0 0 0-5.6-5.6 5.599 5.599 0 0 0-5.6 5.6 5.6 5.6 0 0 0 5.6 5.6 11.178 11.178 0 0 1 2.8 22.002v5.998h-5.6v-5.998a11.198 11.198 0 0 1-8.4-10.802h5.6a5.6 5.6 0 1 0 11.2 0 5.6 5.6 0 0 0-5.6-5.6 11.178 11.178 0 0 1-2.8-22.003v-5.997h5.6zm47.6 22.4v5.6h-28v-5.6h28zm-72.8 0v5.6h-28v-5.6h28zm-11.2-50.4v5.6h-16.8v-5.6h16.8zm28 0v5.6h-16.8v-5.6h16.8zm28 0v5.6h-16.8v-5.6h16.8zm28 0v5.6h-16.8v-5.6h16.8z"
}));

var SvgImgRegBankbook = function SvgImgRegBankbook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 163,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgRegBankbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_reg_bankbook.9ca4c8d8.svg";
export { ForwardRef as ReactComponent };